<template>
	<header class="head-top">
		<div class="container">
			<router-link to="/home" class="logo">
				<img src="@/assets/logo.jpg" alt="logo" />
			</router-link>
			<button type="button" class="menu-btn" aria-label="打开菜单" @click="toggleMenu" :class="{ active: menuOpen }">
				<span class="menu-line"></span>
				<span class="menu-line"></span>
				<span class="menu-line"></span>
			</button>
			<nav class="nav-links" :class="{ open: menuOpen }">
				<a :href="homeUrl" @click="handleHomeClick">首页</a>
				<div class="nav-dropdown" :class="{ open: solutionOpen }" @mouseleave="handleSolutionsMouseLeave">
					<button type="button" class="nav-dropdown-trigger" @click.stop="toggleSolutions">
						解决方案
					</button>
					<div class="nav-dropdown-menu">
						<a v-for="item in solutionMenuList" :key="item.name" :href="item.href"
							@click="handleSolutionClick($event, item)">{{ item.name }}</a>
					</div>
				</div>
				<a :href="registerUrl" @click="closeMenu">立即注册</a>
				<a href="https://lbscq.wxpsy.cn/landing/#screens" target="_blank" @click="closeMenu">代码生成器</a>
				<button type="button" class="btn-demo" @click="openDemoCenter">演示中心</button>
			</nav>
		</div>
		<div class="nav-overlay" v-show="menuOpen" @click="closeMenu" aria-hidden="true"></div>

		<!-- 演示中心弹窗 -->
		<Teleport to="body">
			<div class="demo-modal-mask" v-show="demoCenterOpen" @click.self="closeDemoCenter">
				<div class="demo-modal">
					<div class="demo-modal-header">
						<h3>演示中心</h3>
						<button type="button" class="demo-modal-close" @click="closeDemoCenter"
							aria-label="关闭">×</button>
					</div>
					<div class="demo-modal-body">
						<aside class="demo-sidebar">
							<button v-for="item in demoMenuList" :key="item.id"
								:class="['demo-sidebar-item', { active: currentDemoId === item.id }]"
								@click="currentDemoId = item.id">
								<span class="demo-sidebar-icon">{{ item.icon }}</span>
								<span class="demo-sidebar-text">{{ item.name }}</span>
							</button>
						</aside>
						<div class="demo-content">
							<div v-for="item in demoMenuList" :key="item.id" v-show="currentDemoId === item.id"
								class="demo-content-panel">
								<table class="demo-table">
									<thead>
										<tr>
											<th>产品</th>
											<th>演示网址</th>
											<th>账号</th>
											<th>密码</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="row in item.demos" :key="row.product">
											<td>{{ row.product }}</td>
											<td><a :href="row.url" target="_blank" rel="noopener">{{ row.url }}</a>
											</td>
											<td>{{ row.account }}</td>
											<td>{{ row.password }}</td>
										</tr>
									</tbody>
								</table>
								<div class="demo-qrcodes" v-if="item.qrcodes && item.qrcodes.length">
									<div class="demo-qrcode-item" v-for="qr in item.qrcodes" :key="qr.label">
										<div class="demo-qrcode-box">
											<img v-if="qr.img" :src="qr.img" :alt="qr.label" class="demo-qrcode-img" />
											<div v-else class="demo-qrcode-placeholder">二维码</div>
										</div>
										<span class="demo-qrcode-label">{{ qr.label }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Teleport>
	</header>
</template>

<script>
	export default {
		name: 'Head',
		data() {
			return {
				menuOpen: false,
				solutionOpen: false,
				demoCenterOpen: false,
				currentDemoId: 'standard-php',
				windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
				solutionMenuList: [{
						name: '心理测评SaaS系统产品手册',
						href: '/solution-manual#core-value-1'
					},
					{
						name: '看守所监狱心理测评与心理矫治管理系统',
						href: '/prison-solution'
					},
					{
						name: '教育局心理测评系统建设方案',
						href: '/education-solution'
					},
					{
						name: '中小学心理测评系统方案',
						href: '/school-solution'
					},
					{
						name: '公安民警心理测评系统完整实施方案',
						href: '/police-solution'
					},
					{
						name: '大学心理测评实施方案',
						href: '/university-evaluation'
					},
					{
						name: '交通驾驶员心理测评解决方案',
						href: '/traffic-psychology'
					}
				],
				demoMenuList: [{
						id: 'standard-php',
						name: '预约咨询版PHP',
						icon: '🏢',
						demos: [{
							product: '管理后台',
							url: 'https://new.laiweb.cn/admin#/login',
							account: 'admin',
							password: 'admin'
						}],
						qrcodes: [{
							label: '小程序演示',
							img: require('@/assets/xcx2.jpg')
						}]
					},
					{
						id: 'multi-php',
						name: 'SAAS化多应用版（B2B2C）',
						icon: '📦',
						demos: [{
							product: 'H5端',
							url: 'https://wanxiang.s.laiweb.cn/h5/#/',
							account: '-',
							password: '-'
						}, {
							product: '后台演示地址',
							url: 'https://wanxiang.s.laiweb.cn/admin/index.html#/login',
							account: 'wanxiangceping',
							password: 'wanxiangceping'
						}],
						qrcodes: [{
							label: '小程序演示',
							img: require('@/assets/xcx1.jpg')
						}]
					}
				]
			}
		},
		computed: {
			// 小屏（<768px）跳 H5，大屏跳 PC 登录
			registerUrl() {
				return this.windowWidth < 768 ?
					'https://s.wxpsy.cn/customer-h5/#/' :
					'https://s.wxpsy.cn/customer/#/login'
			},
			homeUrl() {
				return '/home#products'
			}
		},
		mounted() {
			window.addEventListener('resize', this.updateWindowWidth)
			this.updateWindowWidth()
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateWindowWidth)
		},
		methods: {
			updateWindowWidth() {
				this.windowWidth = window.innerWidth
			},
			toggleMenu() {
				this.menuOpen = !this.menuOpen
				if (!this.menuOpen) {
					this.solutionOpen = false
				}
			},
			closeMenu() {
				this.menuOpen = false
				this.solutionOpen = false
			},
			toggleSolutions() {
				this.solutionOpen = !this.solutionOpen
			},
			handleSolutionsMouseLeave() {
				if (this.windowWidth > 768) {
					this.solutionOpen = false
				}
			},
			handleSolutionClick(event, item) {
				if (item && item.href && item.href.startsWith('/')) {
					event.preventDefault()
					const targetPath = item.href.split('#')[0] || item.href
					this.$router.push(targetPath).then(() => {
						this.scrollToTop()
					}).catch(() => {})
				}
				this.closeMenu()
			},
			scrollToTop() {
				window.scrollTo(0, 0)
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			},
			handleHomeClick(event) {
				const isHomePage = this.$route && this.$route.path === '/home'
				if (!isHomePage) {
					event.preventDefault()
					this.$router.push('/home#products')
				}
				this.closeMenu()
			},
			openDemoCenter() {
				this.closeMenu()
				this.demoCenterOpen = true
			},
			closeDemoCenter() {
				this.demoCenterOpen = false
			}
		}
	}
</script>

<style scoped>
	.head-top {
		height: 64px;
		background: #fff;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 1000;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 24px;
		height: 100%;
		display: flex;
		align-items: center;
	}

	.logo {
		width: 98px;
		height: 46px;
		margin-right: 48px;
		display: block;
	}

	.logo img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.nav-links {
		display: flex;
		align-items: center;
		gap: 32px;
		flex: 1;
	}

	.nav-links a {
		color: #333;
		text-decoration: none;
		font-size: 15px;
		white-space: nowrap;
	}

	.nav-links a:hover {
		color: #1890ff;
	}

	.nav-dropdown {
		position: relative;
	}

	.nav-dropdown-trigger {
		padding: 0;
		border: none;
		background: none;
		color: #333;
		font-size: 15px;
		cursor: pointer;
		white-space: nowrap;
	}

	.nav-dropdown-trigger:hover {
		color: #1890ff;
	}

	.nav-dropdown-menu {
		position: absolute;
		top: calc(100% + 12px);
		left: 0;
		min-width: 320px;
		padding: 8px 0;
		background: #fff;
		border: 1px solid #f0f0f0;
		border-radius: 6px;
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
		opacity: 0;
		visibility: hidden;
		transform: translateY(6px);
		transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
		z-index: 1002;
	}

	.nav-dropdown:hover .nav-dropdown-menu,
	.nav-dropdown.open .nav-dropdown-menu {
		opacity: 1;
		visibility: visible;
		transform: translateY(0);
	}

	.nav-dropdown-menu a {
		display: block;
		padding: 10px 14px;
		font-size: 14px;
		color: #333;
		white-space: normal;
		line-height: 1.5;
	}

	.nav-dropdown-menu a:hover {
		background: #f5f9ff;
		color: #1890ff;
	}

	.nav-right .btn-login {
		display: inline-block;
		padding: 8px 20px;
		background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
		color: #fff;
		border-radius: 4px;
		text-decoration: none;
		font-size: 14px;
	}

	.nav-right .btn-login:hover {
		opacity: 0.9;
	}

	.nav-links .btn-demo {
		margin-left: auto;
	}

	.btn-demo {
		padding: 8px 24px;
		background: #1890ff;
		color: #fff;
		border: none;
		border-radius: 20px;
		font-size: 14px;
		cursor: pointer;
		white-space: nowrap;
	}

	.btn-demo:hover {
		background: #096dd9;
	}

	/* 移动端菜单按钮：默认隐藏 */
	.menu-btn {
		display: none;
		width: 40px;
		height: 40px;
		padding: 0;
		border: none;
		background: none;
		cursor: pointer;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 6px;
		margin-left: auto;
		position: relative;
		z-index: 1003;
	}

	.menu-line {
		display: block;
		width: 22px;
		height: 2px;
		background: #333;
		border-radius: 1px;
		transition: transform 0.25s, opacity 0.25s;
	}

	.menu-btn.active .menu-line:nth-child(1) {
		transform: translateY(8px) rotate(45deg);
	}

	.menu-btn.active .menu-line:nth-child(2) {
		opacity: 0;
	}

	.menu-btn.active .menu-line:nth-child(3) {
		transform: translateY(-8px) rotate(-45deg);
	}

	/* 点击遮罩关闭菜单 */
	.nav-overlay {
		display: none;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.4);
		z-index: 999;
	}

	/* 响应式：调整头部在中小屏下的布局与字号 */
	@media (max-width: 1024px) {
		.head-top {
			height: 56px;
		}

		.container {
			padding: 0 16px;
		}

		.logo {
			width: 90px;
			height: 56px;
			margin-right: 24px;
		}

		.nav-links {
			gap: 20px;
		}

		.nav-links a {
			font-size: 14px;
		}

		.nav-dropdown-trigger {
			font-size: 14px;
		}
	}

	/* 手机屏：显示菜单按钮，导航改为竖向展开 */
	@media (max-width: 768px) {
		.head-top {
			height: 56px;
		}

		.container {
			padding: 0 12px;
		}

		.logo {
			margin-right: 0;
		}

		.menu-btn {
			display: flex;
		}

		.nav-links {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: auto;
			width: min(76vw, 320px);
			background: #fff;
			box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);
			flex-direction: column;
			align-items: stretch;
			gap: 0;
			padding: 56px 0 0;
			overflow-y: auto;
			transform: translateX(100%);
			transition: transform 0.28s ease;
			z-index: 1002;
		}

		.nav-links.open {
			transform: translateX(0);
		}

		.nav-links a,
		.nav-links .nav-dropdown-trigger,
		.nav-links .btn-demo {
			display: block;
			padding: 14px 24px;
			font-size: 15px;
			border-bottom: 1px solid #f0f0f0;
			width: 100%;
			box-sizing: border-box;
			text-align: left;
			background: none;
			border-left: none;
			border-right: none;
			border-top: none;
			border-radius: 0;
			margin-left: 0;
		}

		.nav-links .nav-dropdown {
			width: 100%;
		}

		.nav-links .nav-dropdown-trigger {
			text-align: left;
			border-bottom: 1px solid #f0f0f0;
		}

		.nav-links .nav-dropdown-menu {
			position: static;
			min-width: 0;
			padding: 0;
			border: none;
			border-radius: 0;
			box-shadow: none;
			opacity: 1;
			visibility: visible;
			transform: none;
			max-height: 0;
			overflow: hidden;
			transition: max-height 0.25s ease;
		}

		.nav-links .nav-dropdown.open .nav-dropdown-menu {
			max-height: 280px;
		}

		.nav-links .nav-dropdown-menu a {
			padding: 12px 36px;
			font-size: 14px;
			border-bottom: 1px solid #f5f5f5;
		}

		.nav-links .btn-demo {
			color: #333;
			cursor: pointer;
		}

		.nav-links .btn-demo:hover {
			color: #1890ff;
		}

		.nav-links a:last-child,
		.nav-links .nav-dropdown-menu a:last-child,
		.nav-links .btn-demo:last-child {
			border-bottom: none;
		}

		.nav-overlay {
			display: block;
			z-index: 1001;
		}
	}

	@media (max-width: 480px) {
		.head-top {
			height: 48px;
		}

		.logo {
			width: 80px;
			height: 45px;
			margin-right: 0;
		}

		.nav-links {
			width: 72vw;
			padding-top: 48px;
		}

		.nav-links a {
			font-size: 14px;
			padding: 12px 20px;
		}
	}

	/* 演示中心弹窗 */
	.demo-modal-mask {
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 2000;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
		box-sizing: border-box;
	}

	.demo-modal {
		background: #fff;
		border-radius: 8px;
		width: 100%;
		max-width: 900px;
		max-height: 90vh;
		display: flex;
		flex-direction: column;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
	}

	.demo-modal-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 24px;
		border-bottom: 1px solid #eee;
	}

	.demo-modal-header h3 {
		margin: 0;
		font-size: 18px;
		font-weight: 600;
		color: #333;
	}

	.demo-modal-close {
		width: 32px;
		height: 32px;
		border: none;
		background: none;
		font-size: 24px;
		line-height: 1;
		color: #999;
		cursor: pointer;
		border-radius: 4px;
	}

	.demo-modal-close:hover {
		color: #333;
		background: #f5f5f5;
	}

	.demo-modal-body {
		display: flex;
		flex: 1;
		min-height: 0;
		overflow: hidden;
	}

	.demo-sidebar {
		width: 200px;
		flex-shrink: 0;
		border-right: 1px solid #eee;
		padding: 12px 0;
		overflow-y: auto;
	}

	.demo-sidebar-item {
		display: flex;
		align-items: center;
		gap: 10px;
		width: 100%;
		padding: 12px 16px;
		border: none;
		background: none;
		text-align: left;
		cursor: pointer;
		font-size: 14px;
		color: #333;
		transition: background 0.2s, color 0.2s;
	}

	.demo-sidebar-item:hover {
		background: #f5f9ff;
		color: #1890ff;
	}

	.demo-sidebar-item.active {
		background: #e6f4ff;
		color: #1890ff;
	}

	.demo-sidebar-icon {
		width: 24px;
		text-align: center;
		font-size: 16px;
	}

	.demo-sidebar-text {
		flex: 1;
	}

	.demo-content {
		flex: 1;
		padding: 24px;
		overflow-y: auto;
	}

	.demo-content-panel {
		animation: fadeIn 0.2s ease;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.demo-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 14px;
		margin-bottom: 24px;
	}

	.demo-table th,
	.demo-table td {
		border: 1px solid #e8e8e8;
		padding: 10px 12px;
		text-align: left;
	}

	.demo-table th {
		background: #fafafa;
		font-weight: 500;
		color: #333;
	}

	.demo-table td a {
		color: #1890ff;
		text-decoration: none;
	}

	.demo-table td a:hover {
		text-decoration: underline;
	}

	.demo-qrcodes {
		display: flex;
		gap: 32px;
		flex-wrap: wrap;
	}

	.demo-qrcode-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	}

	.demo-qrcode-box {
		width: 120px;
		height: 120px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fafafa;
	}

	.demo-qrcode-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.demo-qrcode-placeholder {
		font-size: 12px;
		color: #999;
	}

	.demo-qrcode-label {
		font-size: 13px;
		color: #666;
	}

	/* 演示中心弹窗 - 自适应 */
	@media (max-width: 768px) {
		.demo-modal-mask {
			padding: 12px;
			align-items: flex-start;
			padding-top: 40px;
		}

		.demo-modal {
			max-width: 100%;
			max-height: calc(100vh - 52px);
			border-radius: 6px;
		}

		.demo-modal-header {
			padding: 12px 16px;
		}

		.demo-modal-header h3 {
			font-size: 16px;
		}

		.demo-modal-body {
			flex-direction: column;
		}

		.demo-sidebar {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
			padding: 12px 16px;
			border-right: none;
			border-bottom: 1px solid #eee;
			overflow-x: auto;
			flex-shrink: 0;
		}

		.demo-sidebar-item {
			flex: 0 0 auto;
			padding: 8px 12px;
			font-size: 13px;
		}

		.demo-content {
			padding: 16px;
			overflow-x: auto;
		}

		.demo-table {
			font-size: 13px;
			margin-bottom: 20px;
			min-width: 400px;
		}

		.demo-table th,
		.demo-table td {
			padding: 8px 10px;
		}

		.demo-qrcodes {
			gap: 24px;
		}

		.demo-qrcode-box {
			width: 100px;
			height: 100px;
		}

		.demo-qrcode-label {
			font-size: 12px;
		}
	}

	@media (max-width: 480px) {
		.demo-modal-mask {
			padding: 8px;
			padding-top: 32px;
		}

		.demo-modal-header {
			padding: 10px 12px;
		}

		.demo-modal-header h3 {
			font-size: 15px;
		}

		.demo-sidebar {
			padding: 10px 12px;
			gap: 6px;
		}

		.demo-sidebar-item {
			padding: 6px 10px;
			font-size: 12px;
		}

		.demo-content {
			padding: 12px;
		}

		.demo-table {
			min-width: 320px;
			font-size: 12px;
		}

		.demo-table th,
		.demo-table td {
			padding: 6px 8px;
		}

		.demo-qrcode-box {
			width: 80px;
			height: 80px;
		}
	}
</style>